import axios from 'axios'
import type { AxiosInstance } from 'axios'
import { authenticationInterceptor } from 'API/interceptors/authenticationInterceptor'
import { csrfInterceptor } from 'API/interceptors/csrfInterceptor'
import { keyFormatterInterceptor } from 'API/interceptors/keyFormatterInterceptor'
import { schemaValidationInterceptor } from 'API/interceptors/schemaValidationInterceptor'
import { responseErrorStatusInterceptor } from 'API/interceptors/responseStatusInterceptor'
import { JSONSchema6 } from 'json-schema'
import defaultOptions from 'API/options/request/defaultOptions'

declare module 'axios' {
  export interface AxiosRequestConfig {
    schema?: JSONSchema6
  }
}

const clients: { [index: string]: AxiosInstance } = {}

enum basePaths {
  common = '',
  execute = import.meta.env.VITE_EXECUTE_BASEPATH,
  iris = import.meta.env.VITE_IRISAPI_BASEPATH,
  system_admin = import.meta.env.VITE_SYSTEM_ADMIN_BASEPATH,
  measurement = import.meta.env.VITE_MEASUREMENT_BASEPATH,
}

const baseHost = import.meta.env.VITE_IRISAPI_HOST

function createIrisApiClient(basePath: basePaths) {
  if (!clients?.[basePath]) {
    const client = axios.create({
      baseURL: baseHost + basePath,
      ...defaultOptions,
    })
    client.interceptors.request.use(authenticationInterceptor)
    client.interceptors.request.use(csrfInterceptor)
    client.interceptors.response.use((response) => response, responseErrorStatusInterceptor)
    client.interceptors.response.use(keyFormatterInterceptor)
    client.interceptors.response.use(schemaValidationInterceptor)
    clients[basePath] = client
  }
  return clients[basePath]
}

export { basePaths, createIrisApiClient }
